import state from '../initialState';

const initialState = {
  ...state,
  data: {},
};

export default initialState;
